export default {
  GENERAL_ACCESS: 'general_access',
  PAYMENT_REMINDER_ACCESS: 'payment_reminder_access',
  CASH_LOG_ACCESS: 'cash_log_access',
  HEAD_ACCOUNTANT_ACCESS: 'head_accountant_access',
  VALUE_ADJUSTMENT_ACCESS: 'value_adjustment_access',
  ORDER_ACCESS: 'order_access',
  CONTRACT_ACCESS: 'contract_access',
  CLIENT_ACCESS: 'client_access',
  UNDO_CONTRACT: 'undo_contract',
  ASSET_ACCESS: 'asset_access'
};
